import cx from 'classnames';
import mapValues from 'lodash/mapValues';
import {
  ClassNames,
  DayPicker as ReactDayPicker,
  DayPickerDefaultProps,
  DayPickerMultipleProps,
  DayPickerRangeProps,
  DayPickerSingleProps,
} from 'react-day-picker';
import libraryStyles from 'react-day-picker/dist/style.module.css';

import styles from './daypicker.module.less';

const dayPickerStyles: ClassNames = {
  root: styles.root,
  day: styles.day,
  day_range_end: styles.dayRange,
  day_range_start: styles.dayRange,
  day_range_middle: styles.dayRangeMiddle,
  day_selected: styles.daySelected,
  caption: styles.caption,
  caption_label: styles.captionLabel,
  month: styles.month,
  head_cell: styles.headCell,
  months: styles.months,
  dropdown: styles.dropdown,
};

export const DayPicker = <
  Props extends
    | DayPickerDefaultProps
    | DayPickerSingleProps
    | DayPickerMultipleProps
    | DayPickerRangeProps
>(
  props: Props
) => {
  // Apply the zola default styles, the day picker default styles and any custom styles passed in as props
  const classNames = mapValues(libraryStyles as ClassNames, (value, key) => {
    const { classNames: classNamesFromProps } = props;
    return cx(
      dayPickerStyles[key as keyof typeof dayPickerStyles],
      classNamesFromProps?.[key as keyof typeof dayPickerStyles],
      value
    );
  });

  return <ReactDayPicker className={styles.root} {...props} classNames={classNames} />;
};
